import { getAnalytics, isSupported } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  type UserCredential,
  getAuth,
  signInWithCredential,
  signInWithPopup,
} from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDvq3QCmMlwt2Rug0916CMRGzovkf9b-60',
  appId: '1:437902783863:web:a323bea1f8bd02495b9d72',
  authDomain: 'patchooli-123.firebaseapp.com',
  measurementId: 'G-5Z0BX4YYYG',
  messagingSenderId: '437902783863',
  projectId: 'patchooli-123',
  storageBucket: 'patchooli-123.firebasestorage.app',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = isSupported().then((supported) => (supported ? getAnalytics(app) : null));
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Add scopes for Google provider.
provider.addScope('profile');
provider.addScope('email');

// Set custom parameters.
provider.setCustomParameters({
  prompt: 'select_account',
});

const signInWithGoogle = async (token: string) => {
  const credential = GoogleAuthProvider.credential(token);
  signInWithCredential(auth, credential)
    .then((userCredential: UserCredential) => {
      console.log('Firebase sign-in successful.', userCredential);
    })
    .catch((error) => {
      console.error('Firebase sign-in failed.', error);
    });
};

export { analytics, auth, provider, signInWithGoogle, signInWithPopup };
